import { useQuery } from "@apollo/client";
import { ButtonNav } from "Components/ButtonNav";
import { Section } from "Components/Section";
import { applicationByKeyQuery } from "generated/graphql";
import React from "react";
import { useParams } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { hasValue } from "Tools";
import { ApplicationNotFoundPage } from "./ApplicationNotFoundPage";
import { LcpPaths } from "./LcpPaths";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function ApplicationCompletePage() {
  const { securityKey } = useParams<{ securityKey: string }>();
  const { data } = useQuery(applicationByKeyQuery, {
    variables: { securityKey },
  });
  if (!data) {
    return <>Loading...</>;
  }
  const app = data.applicationByKey;
  if (!hasValue(app) || !hasValue(app.reapplicationKey)) {
    return <ApplicationNotFoundPage />;
  }
  return (
    <LcpAppPageWrapper isWide documentTitle={"Thank You"}>
      <Section title="Thank You">
        <div style={{ marginBottom: "1em" }}>Your transaction is complete.</div>
        <div>
          Thank you for purchasing {serverConstants.InsuranceName} through{" "}
          {serverConstants.CompanyName}.
        </div>
        <ButtonNav>
          <a
            className="button is-primary"
            href={LcpPaths.Reapply({ reapplicationKey: app.reapplicationKey })}
          >
            Get Another Quote
          </a>
        </ButtonNav>
        <nav style={{ textAlign: "center", marginTop: "1em" }}>
          <a href={serverConstants.StaticSiteUrl}>
            Return to {serverConstants.StaticSiteHost}
          </a>
        </nav>
      </Section>
    </LcpAppPageWrapper>
  );
}
